import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Panel } from '../../../../components/Layout/Panel';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Subtext } from '../../../../components/Title';

// Assets
import { device } from '../../../../styles/variables';
import panel from '../../../../assets/images/pages/bridging-the-gap/professional-panel.jpg';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${panel}) no-repeat center;
  background-size: cover;
  padding-top: 1px;
  margin-top: -1px;
  margin-bottom: -1px;
  background-position: 0 0;
  @media ${device.tablet} {
    background-position: 100% 350px;
  }
  @media ${device.laptop} {
    background-position: 0 0;
  }
  @media ${device.mobileS} and (max-width: 600px) {
    background-position: 100% 350px;
  }

  .title {
    padding: 20px;
    @media ${device.tablet} {
      padding: 40px;
    }
    @media ${device.laptop} {
      padding: 80px;
    }

    @media ${device.mobileS} {
      height: 40%;
      top: 0;
    }

    h2 {
      max-width: 100%;
    }

    .subtext {
      max-width: 453px;
      font-size: 16px;
      line-height: 36px;
    }
  }

  .panel {
    width: 100%;
    height: 403px;
    @media ${device.mobileS} {
      height: 46%;
      top: 0;
    }
    @media ${device.tablet} {
      height: 50%;
      height: 346px;
    }
    @media ${device.laptop} {
      width: 50%;
    }

    .title {
      padding: 25px;

      .subtext {
        max-width: 100%;
      }
    }
  }
`;

const ProfessionalPanelScreen = () => (
  <StyledScreen>
    <ContentContainer>
      <Panel className="panel " top="unset" bottom="0">
        <Title primary={false} className="title">
          Professional panel
          <Subtext className="subtext">
            Instead of interviews, we suggested filming an expert panel to represent the importance
            of a multidisciplinary approach to patient management. We assembled experts from
            optometry, psychology, and occupational therapy to draw the viewer into a peer
            discussion about each patient.
          </Subtext>
        </Title>
      </Panel>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(ProfessionalPanelScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/screens/ProfessionalPanel.jsx